import { useState, useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import axios from "axios";
import { LoadScript, Autocomplete } from "@react-google-maps/api";

const GOOGLE_LIBRARIES = ["places"];

export default function Add_data_modal({
  select_data,
  open_update_data_modal,
  onUpdateCharging,
}) {
  const [ren, setRen] = useState(false);
  const [update_modal_data, setUpdate_modal_data] = useState(select_data);
  const [add_data_modal_Show, set_update_data_modal_Show] = useState(false);
  const [errors, setErrors] = useState({});
  const [autocomplete, setAutocomplete] = useState(null);
  const [locationInput, setLocationInput] = useState("");

  // useEffect(() => {
  //   if (select_data) {
  //     setUpdate_modal_data({
  //       ...select_data,
  //     });
  //   }
  // }, [select_data]);
  useEffect(() => {
    if (select_data) {
      const locations = select_data.charging_locations || [];

      const coordinates = locations.map((loc) => ({
        latitude: loc.latitude,
        longitude: loc.longitude,
      }));

      const location_names = locations.map((loc) => loc.location_name);

      setUpdate_modal_data({
        ...select_data,
        coordinates,
        location_names,
      });
    }
  }, [select_data]);

  useEffect(() => {
    set_update_data_modal_Show(open_update_data_modal.modal_open);
  }, [open_update_data_modal]);

  const handleClose = () => {
    set_update_data_modal_Show(false);
  };

  const onLoad = (autoComp) => {
    setAutocomplete(autoComp);
  };

  const validateFields = () => {
    const newErrors = {};
    if (
      !update_modal_data.coordinates ||
      update_modal_data.coordinates.length === 0
    ) {
      newErrors.coordinates = "At least one location must be added.";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const onPlaceChanged = () => {
    if (autocomplete !== null) {
      const place = autocomplete.getPlace();
      const lat = place.geometry?.location?.lat();
      const lng = place.geometry?.location?.lng();
      const name = place.formatted_address || place.name;

      if (lat && lng && name) {
        setUpdate_modal_data((prevData) => ({
          ...prevData,
          location_names: [...(prevData.location_names || []), name],
          coordinates: [
            ...(prevData.coordinates || []),
            { latitude: lat, longitude: lng },
          ],
        }));
        setLocationInput(""); // Clear input field
      }
    }
  };

  const handleUpdate = async () => {
    const token = localStorage.getItem("token");

    if (!validateFields()) {
      Swal.fire("Please add at least one location", "", "error");
      return;
    }

    Swal.fire({
      icon: "warning",
      title: "Are you sure you want to update the locations?",
      showCancelButton: true,
      confirmButtonText: "Yes",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const vehicleId = update_modal_data.vehicle_id?._id;
          if (!vehicleId) throw new Error("Vehicle ID not found");

          const payload = {
            charging_locations: update_modal_data.coordinates,
          };

          const res = await axios.put(
            `${process.env.REACT_APP_BASE_URL}/api/v4/charging-data/${vehicleId}/add-location`,
            payload,
            {
              headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json",
              },
            }
          );

          if (res.data.success) {
            Swal.fire("Locations updated successfully", "", "success");
            onUpdateCharging(res.data.data); // Pass updated data to parent
            setRen(!ren);
            handleClose();
          } else {
            Swal.fire("Update failed", res.data.message || "", "error");
          }
        } catch (error) {
          console.error(error);
          Swal.fire("Update failed", error.message || "", "error");
        }
      }
    });
  };

  const handleRemoveLocation = (index) => {
    setUpdate_modal_data((prevData) => ({
      ...prevData,
      location_names: (prevData.location_names || []).filter(
        (_, i) => i !== index
      ),
      coordinates: (prevData.coordinates || []).filter((_, i) => i !== index),
    }));
  };

  return (
    <>
      <Modal show={add_data_modal_Show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Update Charging Locations</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <div className="mb-3">
              <label>
                <b>Charging Locations & Coordinates</b>
              </label>
              {(update_modal_data.coordinates || []).length > 0 ? (
                <ul className="list-group">
                  {update_modal_data.coordinates.map((coord, index) => (
                    <li
                      key={index}
                      className="list-group-item d-flex justify-content-between align-items-center"
                    >
                      <div>
                        <strong>
                          {(update_modal_data.location_names || [])[index] ||
                            "Unnamed"}
                        </strong>{" "}
                        — {coord.latitude}, {coord.longitude}
                      </div>
                      <button
                        type="button"
                        className="btn btn-danger btn-sm"
                        onClick={() => handleRemoveLocation(index)}
                      >
                        Remove
                      </button>
                    </li>
                  ))}
                </ul>
              ) : (
                <p>No locations added yet.</p>
              )}
              {errors.coordinates && (
                <div className="text-danger mt-1">{errors.coordinates}</div>
              )}
            </div>

            <Form.Group className="mb-3">
              <Form.Label>Search & Add Location *</Form.Label>
              <LoadScript
                googleMapsApiKey={process.env.REACT_APP_BASE_API}
                libraries={GOOGLE_LIBRARIES}
              >
                <Autocomplete onLoad={onLoad} onPlaceChanged={onPlaceChanged}>
                  <Form.Control
                    type="text"
                    placeholder="Search places..."
                    value={locationInput}
                    onChange={(e) => setLocationInput(e.target.value)}
                    onKeyDown={(e) => {
                      if (e.key === "Enter") {
                        e.preventDefault(); // Prevent form submission on Enter
                      }
                    }}
                  />
                </Autocomplete>
              </LoadScript>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button
            variant="primary"
            className="btn btn-sm"
            onClick={handleUpdate}
          >
            Update Locations
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}
